import { BankDelivery } from "@/modules/bank/domain/BankDelivery";
import { BankDeliveryRepository } from "@/modules/bank/domain/BankDeliveryRepository";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher, sync_command_dispatcher } from "@/api/client";

export class ApiBankDeliveryRepository implements BankDeliveryRepository{

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor(){
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher
    }        

    api_to_domain(line){
        return new BankDelivery(line.sd_id, line.service, line.start_date,  line.end_date)
    }
    
    async get_data(user_id: number|null):Promise<BankDelivery[]|null>{        
        let contracts = await this.query_dispatcher.dispatch('service.bank.deliveries', {org_id:user_id, counter:false})
        if(contracts.results){
            return contracts.results.map(line => this.api_to_domain(line), this)
        }
        else {
            return []
        }        
    }
}